
export default {
    slug: 'guestlists/templates',
    title: 'Guestlist templates',
    visible: [
        'template.id',
        'template.name',
        'template.subject',
        'status'
    ],
    listview: 'GuestlistTemplatesListView',
    locales: ['common'],
}



// WEBPACK FOOTER //
// ./src/app/store/guestlists/templates/state.js